// "Tap or insert your card" — the bridge sale is in flight; we're waiting
// for the IM30 to report progress. No cancel here (the terminal owns the
// transaction once it starts).

import { ContactlessCard } from "../components/Illustrations";
import { KioskShell } from "../components/KioskShell";
import { useLang } from "../i18n/LangContext";
import { formatCLP } from "../lib/format";
import type { KioskState } from "../state/types";

type AwaitingCard = Extract<KioskState, { phase: "awaiting-card" }>;

export function AwaitCardScreen({ state }: { state: AwaitingCard }) {
  const { t, locale } = useLang();
  return (
    <KioskShell step={3}>
      <div className="screen screen--center">
        <div className="illustration">
          <ContactlessCard />
        </div>
        <h1 className="screen__title">{t("cardTitle")}</h1>
        <div className="stack">
          <span className="screen__eyebrow">{t("cardAmountLabel")}</span>
          <span className="chip chip--amount">
            {formatCLP(state.amountCLP, locale)}
          </span>
        </div>
        <p className="screen__note">{t("cardFollowReader")}</p>
      </div>
    </KioskShell>
  );
}
